module.exports = __webpack_public_path__ + "static/BannerAvailability2x-7995c33c5f6d7ae19dcac49d01018388.jpg";